import parseSupplementalBenefitPlans from './parseSupplementalBenefitPlans'
import getSTMPlansAdditionalData from './getSTMPlansAdditionalData'
import getValidFiltersFromURL from './getValidFiltersFromURL'
import setDurationToBTMPlans from './setDurationToBTMPlans'
import getPlansIdByType from './getPlansIdByType'
import getURLParams from 'utils/DOM/getURLParams'
import getSortFromURL from './getSortFromURL'
import getTypeIds from './getTypeIds'
import {
  BTM,
  ADD_ONS_PLANS,
  NOT_STM_PLANS,
  DENTAL,
  LATITUDE,
  FIXED,
  EPIC,
  AMERITAS_DENTAL,
  AMERITAS_VISION
} from 'core/constants/products'
import parseDefaultPlans from '../parseDefaultPlans'
import { IS_ENROLL } from 'core/constants/environment'
import filterEpicPlans from 'utils/pivot/filterEpicPlans/filterEpicPlans'

const filterSTM = item => !NOT_STM_PLANS.includes(item)

function parsePlanFBM(plan) {
  plan.durationsArray = plan.durations
  const durations = {}

  for (const duration of plan.durationsArray) {
    durations[duration.policyDuration] = {}
    durations[duration.policyDuration][1] = duration
  }

  plan.durations = durations

  return plan
}

function parseResponseSTM([quoteResponse, recEngine, defaultPlansResponse]) {
  if (!quoteResponse.hasError) {
    const URLParams = getURLParams()
    const epicPlans = quoteResponse.plansByType[EPIC]

    if (epicPlans) {
      const { planIds, filteredPlans } = filterEpicPlans(
        IS_ENROLL,
        epicPlans,
        quoteResponse.plans
      )
      quoteResponse.plansByType[EPIC] = planIds

      quoteResponse.plans = filteredPlans
    }

    const stmTypes = getTypeIds(filterSTM, quoteResponse.plansByType)

    const plansSTM = getPlansIdByType(stmTypes, quoteResponse.plansByType)

    const { filterOptions, brochuresByProductType, filterOptionsByProductType } =
      getSTMPlansAdditionalData(plansSTM, quoteResponse.plans, quoteResponse.brochures)

    const dentalPlans = getPlansIdByType(
      [DENTAL, LATITUDE, AMERITAS_DENTAL, AMERITAS_VISION],
      quoteResponse.plansByType
    )
    for (const id of dentalPlans) {
      const plan = quoteResponse.plans[id]
      const brochure = quoteResponse.brochures[plan.brochureId]
      brochuresByProductType[plan.productId] = brochure
    }

    quoteResponse.filterOptions = filterOptions
    quoteResponse.brochuresByProductType = brochuresByProductType

    const { filters, defaultPeriod } = getValidFiltersFromURL(
      URLParams,
      quoteResponse.filterOptions
    )

    const defaultFiltersByProductType = parseDefaultPlans(
      filterOptionsByProductType,
      quoteResponse.plans,
      defaultPlansResponse
    )

    quoteResponse.defaultFiltersByProductType = defaultFiltersByProductType
    quoteResponse.filtersByProductType = defaultFiltersByProductType
    quoteResponse.filters = filters
    quoteResponse.filterOptionsByProductType = filterOptionsByProductType
    quoteResponse.defaultPeriod = defaultPeriod
    quoteResponse.period = filters.period || defaultPeriod
    quoteResponse.plansSTM = plansSTM
    quoteResponse.sortBy = getSortFromURL(URLParams.sort)
    quoteResponse.plansAddOn = getPlansIdByType(ADD_ONS_PLANS, quoteResponse.plansByType)
    // parse supplemental
    parseSupplementalBenefitPlans(quoteResponse)

    // set duration to BTM plans
    setDurationToBTMPlans(quoteResponse)

    quoteResponse.plansBTM = quoteResponse.plansByType[BTM]
    quoteResponse.plansFBM = quoteResponse.plansByType[FIXED]
    if (quoteResponse.plansFBM) {
      quoteResponse.plansByType[FIXED].map(id => parsePlanFBM(quoteResponse.plans[id]))
    }
  }

  return [quoteResponse, recEngine]
}

export default parseResponseSTM
